export default {"src":"/_next/static/media/zoom-out.c3f4b3a9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};